import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import gravatarUrl from '@afosto/utils/gravatarUrl';
import InviteActions from './InviteActions';

export const avatarFormatter = (cell, row) => (
  <Avatar
    src={gravatarUrl(row.signee, {
      letterValue: row.signee,
    })}
  />
);

export const inviteActionsFormatter = (cell, row) => <InviteActions invite={row} />;

export default avatarFormatter;
